import { render, staticRenderFns } from "./QuestionStep.vue?vue&type=template&id=531e7ec8&"
import script from "./QuestionStep.vue?vue&type=script&lang=js&"
export * from "./QuestionStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports